(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alpine-product"] && !Shopify.designMode) return;
  try {
    
function initAlpine(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  root.querySelectorAll('.va-thumb').forEach(button=>button.addEventListener('click',()=>{
    root.querySelectorAll('.va-photo').forEach(photo=>{photo.hidden=photo.id!==button.getAttribute('aria-controls');});
    root.querySelectorAll('.va-thumb').forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb===button)));
  }));
  const selector=root.querySelector('.va-variant');
  if(selector)selector.addEventListener('change',()=>{
    const option=selector.selectedOptions[0];
    root.querySelector('.va-price').textContent=option.dataset.price;
    const compare=root.querySelector('.va-compare');
    compare.textContent=option.dataset.compare;
    compare.hidden=!option.dataset.compare;
    root.querySelector('.va-sale').hidden=!option.dataset.compare;
    const add=root.querySelector('.va-add');
    add.disabled=option.dataset.available!=='true';
    add.textContent=add.disabled?add.dataset.soldLabel:add.dataset.availableLabel;
  });
}
document.querySelectorAll('.va').forEach(initAlpine);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.va').forEach(initAlpine));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enduro-product"] && !Shopify.designMode) return;
  try {
    
function initEnduro(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  root.querySelectorAll('.vm-thumb').forEach(button=>button.addEventListener('click',()=>{
    root.querySelectorAll('.vm-photo').forEach(photo=>{photo.hidden=photo.id!==button.getAttribute('aria-controls');});
    root.querySelectorAll('.vm-thumb').forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb===button)));
  }));
  const selector=root.querySelector('.vm-variant');
  if(selector)selector.addEventListener('change',()=>{
    const option=selector.selectedOptions[0];
    root.querySelector('.vm-price').textContent=option.dataset.price;
    const compare=root.querySelector('.vm-compare');
    compare.textContent=option.dataset.compare;
    compare.hidden=!option.dataset.compare;
    root.querySelector('.vm-sale').hidden=!option.dataset.compare;
    const add=root.querySelector('.vm-add');
    add.disabled=option.dataset.available!=='true';
    add.textContent=add.disabled?add.dataset.soldLabel:add.dataset.availableLabel;
  });
}
document.querySelectorAll('.vm').forEach(initEnduro);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.vm').forEach(initEnduro));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
